<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.userpowersourceinfo_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/userpowersource/userpowersourceinfo';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        searchMenuSpan: 6,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        indexLabel: '序号',
        column: [
          {
            label: '用户名',
            prop: 'userName',
            rules: [
              {
                required: true,
                message: '请输入用户名',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '账单周期',
            prop: 'billcycleNo',
            rules: [
              {
                required: true,
                message: '请输入账单周期',
                trigger: 'change',
              },
            ],
            format: 'yyyyMM',
            valueFormat: 'yyyyMM',
            type: 'month',
            search: true,
          },
          {
            label: '天然气用量（单位/m³）',
            prop: 'gasTax',
            rules: [
              {
                required: true,
                message: '请输入天然气用量（单位/m³）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '峰谷电量（单位/kW‧h）',
            prop: 'peakValley',
            rules: [
              {
                required: true,
                message: '请输入峰谷电量（单位/kW‧h）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '平谷电量（单位/kW‧h）',
            prop: 'bottomValley',
            rules: [
              {
                required: true,
                message: '请输入平谷电量（单位/kW‧h）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '低谷电量（单位/kW‧h）',
            prop: 'offPeakValley',
            rules: [
              {
                required: true,
                message: '请输入低谷电量（单位/kW‧h）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注',
            prop: 'remark',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.userpowersourceinfo_add, false),
        viewBtn: this.vaildData(this.permission.userpowersourceinfo_view, false),
        delBtn: this.vaildData(this.permission.userpowersourceinfo_delete, false),
        editBtn: this.vaildData(this.permission.userpowersourceinfo_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
